"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listToDictionaryById = void 0;
const ramda_1 = require("ramda");
/**
 * Transform a list of values to dictionary by value.id
 *
 * @param list - Array of values
 * @returns Dictionary of values
 *
 * @public
 *
 * @example
 * ```ts
 * const result = listToDictionaryById([
 *   {id: '1', name: 'john', value: 'doe'},
 *   {id: '2', name: 'ann', value: 'doe'},
 * ]);
 * console.log(result);
 *
 * // -> {
 * //   '1': {id: '1', name: 'john', value: 'doe'},
 * //   '2': {id: '2', name: 'ann', value: 'doe'},
 * // }
 * ```
 */
function listToDictionaryById(list) {
    return (0, ramda_1.zipObj)((0, ramda_1.pluck)('id', list), list);
}
exports.listToDictionaryById = listToDictionaryById;
//# sourceMappingURL=list-to-dictionary-by-id.js.map